import { render, staticRenderFns } from "./AppLoader.vue?vue&type=template&id=78c29634&scoped=true&"
import script from "./AppLoader.vue?vue&type=script&lang=ts&"
export * from "./AppLoader.vue?vue&type=script&lang=ts&"
import style0 from "./AppLoader.vue?vue&type=style&index=0&id=78c29634&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c29634",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VProgressCircular,VSheet})
